import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

@Component({ standalone: true, template: '<p role="status">Opening your workspace…</p>' })
export class AdminHomeComponent implements OnInit {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  async ngOnInit() {
    await this.auth.initialize();
    await this.router.navigateByUrl(this.auth.homePath(), { replaceUrl: true });
  }
}
